import { render, staticRenderFns } from "./checkboxGroup.vue?vue&type=template&id=031f822a"
import script from "./checkboxGroup.vue?vue&type=script&lang=js"
export * from "./checkboxGroup.vue?vue&type=script&lang=js"
import style0 from "./checkboxGroup.vue?vue&type=style&index=0&id=031f822a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports